import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { departmentTypes } from '../../types/allotments';

import { selectDepartments } from '../../user/selectors';

import { H2, Currency, Address } from '../../components';
import { TranslatedCopy } from '../../intl';
import SummaryBlock from '../SummaryBlock';

import { block, buildAccountName, buildNetTotalHeader, buildNetTotalDisplay } from '../utils';

import { ORDERTYPE_STRING_MAP } from '../../orders/constants';

export const OrderSummaryPF = ({ baseClass, order, departments }) => {
  const {
    orderType,
    accountNumber,
    departmentName,
    sapOrderNumber,
    orderNetTotal,
    paymentMethod,
    currencyCode,
    submittedBy,
    userEmail,
    customerPO,
    shipToAddress
  } = order;

  const getBlock = (titleId, value) => block(titleId, value, TranslatedCopy, baseClass);

  const accountNameBlock = getBlock('global.account', buildAccountName(accountNumber, departments, TranslatedCopy));
  const departmentBlock = getBlock('orderstatus.filters.departmentnumber', departmentName);
  const orderNumberBlock = getBlock('global.orderNumber', sapOrderNumber);
  const orderTypeBlock = getBlock('global.orderType', ORDERTYPE_STRING_MAP[orderType] || orderType);
  const purchaseOrderBlock = getBlock('global.purchaseOrder', customerPO);
  const createdByBlock = getBlock('global.createdBy', userEmail);
  const submittedByBlock = getBlock('global.submittedBy', submittedBy);
  const shipToBlock = getBlock('global.shippingAddress', <Address address={shipToAddress} />);
  const netTotalBlock = getBlock(
    buildNetTotalHeader(paymentMethod, TranslatedCopy),
    buildNetTotalDisplay(paymentMethod, orderNetTotal, currencyCode, (value, type) => (
      <Currency value={value} type={type} />
    ))
  );

  return (
    <div className='mb0-sm'>
      <H2>
        <TranslatedCopy id='cart.summary.title' />
      </H2>
      <div className='mt1-sm flex-container row start space-between'>
        <SummaryBlock sections={[accountNameBlock, departmentBlock]} large />
        <SummaryBlock sections={[orderNumberBlock, orderTypeBlock]} />
        <SummaryBlock sections={[purchaseOrderBlock, netTotalBlock]} />
        <SummaryBlock sections={[createdByBlock, submittedByBlock]} large />
        <SummaryBlock sections={[shipToBlock]} large />
      </div>
    </div>
  );
};

OrderSummaryPF.propTypes = {
  baseClass: PropTypes.string.isRequired,
  order: PropTypes.object.isRequired,
  departments: departmentTypes
};

OrderSummaryPF.defaultProps = {
  departments: null
};

const mapStateToProps = state => ({
  departments: selectDepartments(state)
});

export default connect(mapStateToProps, {})(OrderSummaryPF);
